RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const ReactCurationLayout = App.views.ReactCurationLayout;

    models.ReactCurationBridge = models.Curation.extend({
        dontUpdateShell: true,
        buildConfiguration: _.constant(),

        // This is overridden from models.Curation to exclude the export after filters since the React curation does loading a bit differently.
        // Instead, these will be kicked off in _curationLoadingCompleteAsync.
        baseAfterFilters: [],

        // This assumes the React curation will do the right thing for summary, details, and the various visual export flavors.
        getChildView: _.constant(ReactCurationLayout),
        getChildViewAttributes: function () {
            const me = this;

            return {
                id: me.id,
                dashboardModel: me
            };
        },

        // override this as we're going to do the configuration loading in the React Component
        buildEmptyConfigurationView: _.noop,

        // This will be called by the appropriate instance of the useSetExportConfig hook.
        _setBridgeDashboardModel: function (dashboardModel) {
            const me = this;
            me._bridgeDashboardModel = dashboardModel;
        },

        buildScheduledReport: function (attrs) {
            const me = this;

            return me._bridgeDashboardModel.buildScheduledReport(attrs);
        },

        getViewTracking: function () {
            const me = this;

            // Here, `me` is the curation - so if the curation is not focused we want to emit a tracking event for the widget.
            if (!me.isFocus()) {
                return {
                    name: `viewed_${me.getCurationViewTrackingId()}_details_${me.getProp('instanceId')}`,
                    category: 'page_view',
                    options: _.omit(me.getProps(), me.stateProps)
                };
            }

            const options = me.getViewTrackingOptions();

            return {
                name: `viewed_${me.getCurationViewTrackingId()}`,
                category: 'page_view',
                options: options
            };
        },

        _curationLoadingCompleteAsync: async function () {
            const me = this;

            if (!me._recordedLoadingComplete) {
                me._recordedLoadingComplete = true;

                const afterFilters = models.Curation.prototype.baseAfterFilters;
                for (const afterFilter of afterFilters) {
                    await afterFilter(me);
                }
            }
        },

        _setNativationInterceptor: function (navigationInterceptor) {
            const me = this;

            me.__navigationInterceptor = navigationInterceptor;
        },

        navigationInterceptor: function (navigateFcn) {
            const me = this;

            if (me.__navigationInterceptor) {
                return me.__navigationInterceptor(navigateFcn);
            } else {
                return true;
            }
        },

        _setLandscapeChangeRedirectUrl: function (landscapeChangeRedirectUrl) {
            const me = this;

            me.__landscapeChangeRedirectUrl = landscapeChangeRedirectUrl;
        },

        getLandscapeChangeRedirectUrl: function () {
            const me = this;

            if (me.__landscapeChangeRedirectUrl && !me.isDestroyed) {
                return _.result(me, '__landscapeChangeRedirectUrl');
            }
        }
    });

});
